import {
  DeserializedRecord,
  deserializeItem,
  deserializeManyRelationship,
  Deserializer,
  deserializeSingleRelationship,
  JSONAPIManyRelationship,
  JSONAPIRecord,
  JSONAPISingleRelationship
} from "./Helpers";
import {Address} from "./Address";
import {Contact} from "./Contact";
import {HealthProvider} from "./HealthProvider";
import {Information} from "./Information";
import {deserializeInstitution, Institution} from "./Institution";
import {deserializeVersion, Version, VersionDeserializer} from "./Version";

interface Person extends DeserializedRecord<"person"> {
  address?: Address;
  description?: string;
  healthProvider?: HealthProvider;
  information: Information;
  institution?: Institution;
  contacts: Contact[];
  contactsAttributes: Contact[];
  uniqueType?: 'idf' | 'kik' | 'lanr';
  uniqueId?: string;
  versions: Array<Version<Person>>;
}

interface PersonData extends JSONAPIRecord {
  relationships: {
    address: JSONAPISingleRelationship;
    contacts: JSONAPIManyRelationship;
    health_provider: JSONAPISingleRelationship;
    information: JSONAPISingleRelationship;
    institution: JSONAPISingleRelationship;
    versions: JSONAPIManyRelationship;
  }
}

const deserializePerson: Deserializer<Person, PersonData> = (data, included) => {
  const address = deserializeSingleRelationship<Address>(data.relationships.address, included);
  const healthProvider = deserializeSingleRelationship(data.relationships.health_provider, included, deserializeItem<HealthProvider>);
  const information = deserializeSingleRelationship<Information>(data.relationships.information, included);
  const institution = deserializeSingleRelationship<Institution>(data.relationships.institution, included, deserializeInstitution);
  const contacts = deserializeManyRelationship<Contact>(data.relationships.contacts, included);
  const versions = deserializeManyRelationship(data.relationships.versions, included, deserializeVersion as VersionDeserializer<Person>);

  return ({
    ...deserializeItem(data),
    address,
    contacts,
    contactsAttributes: contacts,
    healthProvider,
    information,
    institution,
    versions
  });
};

export type {
  Person
};

export {
  deserializePerson
};
